<template>
  <div class="signup-page position-relative">
    <div class="signup-block left-rest-img">
      <div class="left-side-text">
        <h2>{{ "lng_signup_welcom_text" | translate }}</h2>
        <p>{{ "lng_login_info_1" | translate }}</p>
        <p>{{ "lng_login_info_2" | translate }}</p>
        <v-btn class="my-10" outlined color="#fff" @click="goToLogin">{{ "lng_login_text" | translate }}</v-btn>
      </div>
    </div>
    <div class="signup-block right-rest-detail position-relative">
      <div class="col-md-4 language-block">
        <v-select
          :items="langs"
          @change="changeLanguage()"
          v-model="selectedLanguage"
        >
          <template v-slot:selection="{ item, index }">
            <country-flag :country="item.flag" size="normal" />
            <span class="flags pl-2">{{ item.name }}</span>
          </template>
          <template v-slot:item="{ item, index }">
            <country-flag :country="item.flag" size="normal" />
            <span class="flags pl-2">{{ item.name }}</span>
          </template>
        </v-select>
      </div>
      <div class="container-fluid">
        <flash-message
          v-if="alertToggle"
          :message-data="flashMessageData"
          :alert-toggle="alertToggle"
          @alertToggleUpdate="alertToggle = false"
        ></flash-message>
        <div class="row justify-content-md-center signup-inner-detail">
          <div class="col col-lg-7 col-md-10">
            <div class="logo text-center my-6">
              <a href="#" class="my-4 d-inline-block">
                <img src="../../assets/logo.png" width="240" />
              </a>
              <p class="my-3">{{"lng_create_account_info" | translate}}</p>
            </div>
            <div class="signup-form">
              <v-form ref="signup" lazy-validation>
                <v-text-field
                  :label="'lng_email_text' | translate"
                  type="email"
                  v-model="email"
                  :rules="[rules.required, rules.email]"
                ></v-text-field>
                <v-text-field
                  :label="'lng_password_text' | translate"
                  type="text"
                  @click:append="showPass = !showPass"
                  v-model="password"
                  :rules="[rules.required]"
                ></v-text-field>
                <v-text-field
                  :label="'lng_confirm_password_text' | translate"
                  name="conPassword"
                  type="text"
                  v-model="conPassword"
                  :rules="[() => password === conPassword || passwordMacthError]"
                ></v-text-field>
                <v-text-field 
                  :label="'lng_name_text' | translate"
                  v-model="name" :rules="[rules.required]"></v-text-field>
                <v-text-field 
                  :label="'lng_address1_text' | translate"
                  v-model="address1" :rules="[rules.required]"></v-text-field>
                <v-text-field
                  :label="'lng_address2_text' | translate"
                  v-model="address2"></v-text-field>
                <v-row>
                  <v-text-field
                    style="margin-right: 15px; margin-left: 15px;"
                    :label="'lng_zip_text' | translate"
                    v-model="zip"
                    :rules="[rules.required]"
                  ></v-text-field>
                  <v-text-field
                    style="margin-right: 15px; margin-left: 15px;"
                    :label="'lng_city_text' | translate"
                    v-model="city"
                    :rules="[rules.required]"
                  ></v-text-field>
                </v-row>
                <!-- <v-text-field label="Country" name="country" type="text"></v-text-field> -->
                <v-select
                  class="mt-0 pt-0"
                  :items="countryItems"
                  :value="selectedCountry.value"
                  item-text="name"
                  item-value="value"
                  menu-props="auto"
                  return-object
                  @change="
                      value => {
                        selectedCountry = value;
                      }
                    "
                ></v-select>
                <div class="checkbox-container">
                  <v-checkbox
                    v-model="checkbox"
                    :label="'lng_accept_terms_txt' | translate"
                  ></v-checkbox>
                  <a href="javascript:void(0)" @click="termsModalToggle=true">{{ 'lng_read_terms_txt' | translate }}</a>
                </div>
                <p class="warning-error mt-2" v-if="error">{{ error }}</p>
                <div class="date-header d-flex justify-content-center py-5 mt-3">
                  <v-btn :disabled="!checkbox" :loading="showLoading" color="#0B7894" class="text-white" @click="validate">{{ "lng_signup_text" | translate }}</v-btn>
                </div>
              </v-form>
            </div>
          </div>
        </div>
      </div>
      <span class="app-version">v{{ getAppVersion }}</span>
      <!-- <div class="text-center position-absolute terms mb-2">
        <a href="#">Terms of use. Privacy policy</a>
      </div>-->
    </div>
    <div class="only-mobile">
      <div class="mobile-bottom-signup">
        <h4 class="mb-0 text-white">{{ "lng_signup_welcom_text" | translate }}</h4>
        <v-btn outlined small color="#fff" @click="goToLogin">{{ "lng_login_text" | translate }}</v-btn>
      </div>
    </div>
    <AddBoxModal
      :complete-address="addressObj"
      :user-token="userToken"
      :dialog-title="'lng_add_box_txt' | translate"
      :openDialog="openBoxModal"
      :closeDialog="closeBoxModalFunct"
      @successAddingBox="boxAdded"
    ></AddBoxModal>
    <TermsModal
      :dialog-title="'lng_terms_cond_txt' | translate"
      :openDialog="termsModalToggle"
      :closeDialog="closeTermsModal"
    ></TermsModal>
  </div>
</template>

<script>
import router from "../../router";
import AddBoxModal from "../../components/AddBoxModal";
import { countries } from "../../common/Constant";
import UserService from "../../services/user-service";
import FlashMessage from "../../components/FlashMessage";
import { translateFunc } from '../../common/Filters';
import { languages, appVersion, langFileVersion } from "../../common/Constant.js"
import CountryFlag from "vue-country-flag";
import { storeDataInStorage } from "../../common/HelperFunctions";
import TermsModal from "../../components/TermsModal.vue";


export default {
  name: "Signup",
  components: {
    AddBoxModal,
    FlashMessage,
    CountryFlag,
    TermsModal
  },
  data: () => ({
    langs: languages,
    selectedLanguage: undefined,
    alertToggle: false,
    showPass: false,
    showLoading: false,
    openBoxModal: false,
    email: "",
    password: "",
    conPassword: "",
    name: "",
    address1: "",
    address2: "",
    city: "",
    zip: "",
    error: "",
    rules: {
      required: value => !!value || translateFunc("lng_required_text"),
      counter: value => value.length <= 20 || translateFunc("lng_required_length"),
      email: value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || translateFunc("lng_required_validate_email");
      }
    },
    countryItems: countries,
    selectedCountry: {
      name: "Denmark",
      value: "DK"
    },
    flashMessageData: {},
    addressObj: {},
    userToken: "",
    checkbox: false,
    termsModalToggle: false,
    langVersion: langFileVersion
  }),
  computed: {
    passwordMacthError(){
      return translateFunc('lng_password_match_error_text')
    },
    getAppVersion() {
      return appVersion;
    },
  },
  mounted(){
    let langName = localStorage.getItem('language');
    let filtered = languages.find(e => e.lang === langName);
    if(filtered){
      this.selectedLanguage = filtered;
    } else {
      localStorage.setItem("language", "dk");
      this.selectedLanguage = languages[1];
    }
  },
  methods: {
    goToLogin() {
      router.push("/login");
    },
    closeBoxModalFunct() {
      this.openBoxModal = false;
    },
    handleSignup() {
      this.openBoxModal = true;
    },
    validate() {
      const that = this;
      this.$nextTick(async function() {
        if (that.$refs.signup.validate()) {
          // await this.signup();
          await this.getLatLng();
        }
      });
      // this.openBoxModal = true;
    },

    async getLatLng() {
      let combinedAddress = `${this.address1} ${this.address2} ${this.city} ${this.zip} ${this.selectedCountry.name}`;
      let location = await UserService.googleApiForLatLng(combinedAddress);
      if (location.results.length) {
        await this.signup(location.results[0].geometry.location);
      } else {
        console.log("location not found");
        this.flashMessageData = {
          type: "error",
          messageText: translateFunc("lng_missing_city_txt")
        };
        this.alertToggle = true;
      }
    },

    async signup(location) {
      this.error = "";
      this.showLoading = true;
      let response;
      try {
        response = await UserService.createUserByRole(
          this.email,
          this.password,
          this.name,
          this.address1,
          this.address2,
          this.city,
          this.zip,
          this.selectedCountry.name,
          location.lat,
          location.lng,
          1, "", ""
        );
      } catch (e) {
        this.error = translateFunc("lng_try_again_txt");
        this.showLoading = false;
        console.log("e: ", e);
      }
      if (!response.status) {
        this.error = "";
        this.showLoading = false;
        this.userToken = response.token;
        this.addressObj = {
          addr1: this.address1,
          addr2: this.address2,
          city: this.city,
          zip: this.zip,
          country: this.selectedCountry.name,
          lat: location.lat,
          lng: location.lng
        };
        this.openBoxModal = true;
      } else {
        this.showLoading = false;
        this.error = response.msg;
      }
    },
    // store language to session
    async changeLanguage() {
      localStorage.setItem("language", this.selectedLanguage.lang);
      window.selectedLang = require(`../../../public/locales/${this.selectedLanguage.lang + this.langVersion}.json`);
      // window.I18n = new I18n(this.selectedLanguage.lang);
    },
    boxAdded(){
      storeDataInStorage(this.userToken, "1");
      router.push("/");
    },
    closeTermsModal(){
      this.termsModalToggle = false
    }
  }
};
</script>

<style>
.v-label, label{
  margin-bottom: 0px;
}
.checkbox-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>